import { render, staticRenderFns } from "./safe_link.vue?vue&type=template&id=88937d08&"
import script from "./safe_link.vue?vue&type=script&lang=js&"
export * from "./safe_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports